/** Error classes of the agent chat services. */
import type { AIChatContextGuardStatus } from '@jms/model';

export class DurableRouteError extends Error {

  /**
   * `contextStatus` rides along when the send was refused because the chat's context is full
   * (`CHAT_CONTEXT_LIMIT_REACHED`): the measurement the composer's blocked notice is drawn from,
   * the same one the request-bound stream route sends in its error event.
   */
  constructor(public readonly status: number, public readonly code: string, message: string, public readonly contextStatus: AIChatContextGuardStatus | null = null) {

    super(message);
    this.name = 'DurableRouteError';
  }
}
